// removed by extract-text-webpack-plugin
module.exports = {"column":"_35imEcEiu1nC2_HE5Ytvib","form":"_2KPOfwydRJA1r6MbIaUOBj"};